/*
 * Project: bellcloud
 * File: apps/frontend/src/utils/monitoring/sensorStatusMapper.ts
 * Author: SWAN
 * Created: 2026-03-23
 * Description: 센서 상태 매핑 유틸리티 (Realtime & Playback 공통)
 */

import {
  SystemStatusGroup,
  UNIFIED_STATUS_GROUP_MAP,
  getHighestPriorityGroup,
} from '@packages/types/device/common/system_status_group';

/**
 * 센서 상태를 UI 상태로 매핑
 * - Mini: system_status 비트가 여러 개 동시에 켜지면 첫 번째 레이블만 보면 오판함
 *   (예: "Sensor channel 1 enabled"가 항상 우선순위 0으로 앞에 옴).
 * - Lite/Mini 공통으로 system_status_group의 그룹 우선순위를 그대로 사용.
 */
export function mapSensorStatus(
  status: string[],
  warning?: string | null,
  error?: string | null
): 'Stable' | 'Warning' | 'Alert' {
  if (error && error !== 'No Error') return 'Alert';

  const labels = status.filter(
    (s): s is string => typeof s === 'string' && s.trim().length > 0
  );

  const group = getHighestPriorityGroup(labels, UNIFIED_STATUS_GROUP_MAP);

  if (group === SystemStatusGroup.GroupD) return 'Alert';
  if (group === SystemStatusGroup.GroupB || group === SystemStatusGroup.GroupC) return 'Warning';

  if (warning && warning !== 'No Warning') return 'Warning';

  return 'Stable';
}
